gsap.registerPlugin(ScrollTrigger);

let scaleImgs = gsap.utils.toArray(".scale-img");
scaleImgs.forEach((imgItem, index) => {
  ScrollTrigger.create({
    trigger: imgItem,
    // markers: true,
    animation: gsap.timeline().fromTo(imgItem, {transform: "scale(1.15)"}, {transform: "scale(1)"}),
    start: 'top bottom',
    end: 'bottom top+=30%',
    scrub: 1.3,
  });
}); 